/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PersonRefResponse } from './PersonRefResponse';
export type SubscriptionTransactionListItemResponse = {
    id: string;
    type: SubscriptionTransactionListItemResponse.type;
    planName?: Record<string, any>;
    amount: string;
    /**
     * Subscription status: pending | active | expired | cancelled | paused
     */
    status: string;
    paymentMethod?: Record<string, any>;
    expert?: PersonRefResponse;
    startDate?: Record<string, any>;
    endDate?: Record<string, any>;
    date: string;
};
export namespace SubscriptionTransactionListItemResponse {
    export enum type {
        SUBSCRIPTION = 'subscription',
        ADDON = 'addon',
    }
}

